import PropTypes from 'prop-types';

export default function Search({ searchValue, handleSearchInput, handleFilterClear, getLabel }) {
	return (
		<div className="jobs__control jobs__control--search">
			<form role="search" className="search-form" autoComplete="off">
				<input type="search" className="search-field" placeholder={getLabel('placeholder_search')} value={searchValue} name="q" onInput={handleSearchInput} />
				<div className={`search-form__clear ${searchValue ? 'show' : ''}`} onClick={() => handleFilterClear('q')}></div>
			</form>
		</div>
	);
}

Search.propTypes = {
	searchValue: PropTypes.string,
	handleSearchInput: PropTypes.func,
	handleFilterClear: PropTypes.func,
	getLabel: PropTypes.func,
};
